'use client';

import { clsx } from 'clsx';
import { FC, useEffect } from 'react';

import { getSymbolId } from './SvgIcon.helpers';
import { SvgIcon } from './SvgIcon.type';
import { useSvgSprite } from './SvgSprite';

type Props = SvgIcon & { viewBox: string; name: string };

export const Icon: FC<Props> = ({ children, viewBox, name, ...props }) => {
  const { addIcon } = useSvgSprite();

  useEffect(() => {
    addIcon(name, viewBox, children);
  }, [name, children, addIcon]);

  return <IconPreloaded {...props} viewBox={viewBox} name={name} />;
};

export const IconPreloaded: FC<Omit<Props, 'children'>> = ({ size = 24, name, ...props }) => {
  return (
    <svg
      {...props}
      aria-hidden="true"
      className={clsx('user-select-none relative block fill-current', {
        'size-3': size === 12,
        'size-4': size === 16,
        'size-4.5': size === 18,
        'size-5': size === 20,
        'size-6': size === 24,
        'size-8': size === 32,
        'size-10': size === 40,
      })}
    >
      <use href={`#${getSymbolId(name)}`} />
    </svg>
  );
};
